import * as stylex from '@stylexjs/stylex';
import { useState } from 'react';
import { MdHowToReg, MdPublic, MdGroups, MdCake, MdCalendarToday, MdVerifiedUser, MdPersonAdd, MdCheckCircle } from 'react-icons/md';
import { UserAvatar } from '~components/UserAvatar';
import { styles } from './styles';

// The hero's signature: a stylized map (the app's world — sage land, teal
// water, search-radius circle) where a triby forms in real time. The triby
// card sits on top; below it Maya asks the question and replies roll in as
// each joiner pops onto the card and the capacity bar fills. 12s loop —
// until the visitor hits Join, which freezes the loop at its resting frame
// and adds THEM to the triby.
export function Diorama() {
  const [joined, setJoined] = useState(false);
  return <div {...stylex.props(styles.scene)}>
      <MapField />
      <div {...stylex.props(styles.radius)} />
      <div {...stylex.props(styles.pin)}>
        <span {...stylex.props(styles.pinPulse)} />
        <span {...stylex.props(styles.pinDot)} />
      </div>

      <div {...stylex.props(styles.card)}>
        <div {...stylex.props(styles.cardAvatars)}>
          <UserAvatar name="Maya Ito" size={36} />
          <div {...stylex.props(!joined && styles.join1)}>
            <UserAvatar name="Dev Mehta" size={36} />
          </div>
          <div {...stylex.props(!joined && styles.join2)}>
            <UserAvatar name="Lena Bauer" size={36} />
          </div>
          <div {...stylex.props(!joined && styles.join3)}>
            <UserAvatar name="Sam Okafor" size={36} />
          </div>
          <div {...stylex.props(!joined && styles.join4)}>
            <UserAvatar name="Theo Park" size={36} />
          </div>
          {joined && <div {...stylex.props(styles.popOnce)}>
              <UserAvatar initials="YOU" size={36} />
            </div>}
        </div>
        <span {...stylex.props(styles.cardTitle)}>Late-night ramen run</span>
        <div {...stylex.props(styles.cardPills)}>
          <span {...stylex.props(styles.pill, styles.pillBlue)}>
            <MdVerifiedUser size={14} />
          </span>
          <span {...stylex.props(styles.pill, styles.pillCyan)}>
            <MdPublic size={14} />
          </span>
          <span {...stylex.props(styles.pill, styles.pillGray)}>
            <MdGroups size={14} />
          </span>
          <span {...stylex.props(styles.pill, styles.pillPeach)}>
            <MdCake size={14} />
            24–40
          </span>
        </div>
        <div {...stylex.props(styles.capacity)}>
          <MdHowToReg size={18} {...stylex.props(styles.capacityIcon)} />
          <span {...stylex.props(styles.track)}>
            <span {...stylex.props(styles.fill, joined && styles.fillJoined)} />
          </span>
        </div>
        <div {...stylex.props(styles.cardWhen)}>
          <MdCalendarToday size={14} {...stylex.props(styles.whenIcon)} />
          Tonight at 9:15 PM
        </div>
        {joined ? <div {...stylex.props(styles.joinedRow)}>
            <span {...stylex.props(styles.joinedText)}>
              <MdCheckCircle size={16} />
              You're in.
            </span>
            <a href="#get" {...stylex.props(styles.joinedLink)}>Now do it for real →</a>
          </div> : <button type="button" {...stylex.props(styles.joinButton)} onClick={() => setJoined(true)}>
            <MdPersonAdd size={16} />
            Join this triby
          </button>}
      </div>

      <div {...stylex.props(styles.chat)}>
        <div {...stylex.props(styles.msg, styles.msgLeft, !joined && styles.ask)}>
          <UserAvatar name="Maya Ito" size={22} />
          <div {...stylex.props(styles.bubble, styles.bubbleAsk)}>
            <span {...stylex.props(styles.bubbleName)}>Maya</span>
            {!joined && <span {...stylex.props(styles.bubbleDots)}>
                <i {...stylex.props(styles.dot)} />
                <i {...stylex.props(styles.dot, styles.dotB)} />
                <i {...stylex.props(styles.dot, styles.dotC)} />
              </span>}
            <span {...stylex.props(!joined && styles.bubbleText)}>
              found this little ramen bar — anyone want to come with me? 🍜
            </span>
          </div>
        </div>

        <div {...stylex.props(styles.msg, styles.msgRight, !joined && styles.reply1)}>
          <div {...stylex.props(styles.bubble, styles.bubbleRight)}>
            Yeah, I'm down 🙌
          </div>
          <UserAvatar name="Dev Mehta" size={22} />
        </div>

        <div {...stylex.props(styles.msg, styles.msgLeft, !joined && styles.reply2)}>
          <UserAvatar name="Lena Bauer" size={22} />
          <div {...stylex.props(styles.bubble)}>me too!! ✨</div>
        </div>

        <div {...stylex.props(styles.msg, styles.msgRight, !joined && styles.reply3)}>
          <div {...stylex.props(styles.bubble, styles.bubbleRight)}>
            Hey guys 👋 count me in
          </div>
          <UserAvatar name="Sam Okafor" size={22} />
        </div>

        {joined && <div {...stylex.props(styles.msg, styles.msgRight, styles.slideOnce)}>
            <div {...stylex.props(styles.bubble, styles.bubbleYou)}>
              omw — see you tonight 👋
            </div>
          </div>}
      </div>
    </div>;
}

// Hand-drawn map, zoomed out: a bay fed by a river, parks, a denser road
// network, and neighbouring spot dots.
function MapField() {
  return <svg {...stylex.props(styles.map)} viewBox="0 0 400 533" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <path d="M -20 400 C 60 370 100 430 160 450 C 220 470 230 540 190 560 L -20 560 Z" fill="#1C4A5A" opacity="0.9" />
      <path d="M 96 -10 C 90 70 120 140 100 220 C 84 285 40 330 30 396 C 26 420 40 430 60 424" stroke="#1C4A5A" strokeWidth="10" fill="none" opacity="0.65" />
      <g fill="#D7E4CE" opacity="0.9">
        <ellipse cx="330" cy="70" rx="52" ry="34" />
        <ellipse cx="70" cy="500" rx="40" ry="26" />
        <ellipse cx="230" cy="300" rx="34" ry="22" />
      </g>
      <g stroke="#FFFFFF" strokeWidth="5" fill="none" opacity="0.9">
        <path d="M 170 -10 C 190 90 160 200 200 300 C 230 375 320 420 420 440" />
        <path d="M -10 180 C 100 160 220 200 420 150" />
      </g>
      <g stroke="#FFFFFF" strokeWidth="2.5" fill="none" opacity="0.7">
        <path d="M 40 -10 C 60 80 30 180 60 280" />
        <path d="M 280 -10 C 260 90 300 200 270 320 C 250 400 280 470 310 540" />
        <path d="M -10 320 C 90 300 190 340 300 320 C 340 313 380 330 420 320" />
        <path d="M -10 60 C 70 50 150 70 230 50" />
        <path d="M 120 420 C 180 400 260 430 340 410" />
      </g>
      <g stroke="#FFFFFF" strokeWidth="1.5" fill="none" opacity="0.55">
        <path d="M 210 100 C 250 110 290 95 330 110" />
        <path d="M 90 240 C 130 250 170 235 210 250" />
        <path d="M 230 370 C 270 380 310 365 350 380" />
        <path d="M 140 500 C 180 490 220 505 260 495" />
        <path d="M 350 200 C 370 240 360 280 380 320" />
      </g>
      <g fill="#00C853">
        <circle cx="338" cy="112" r="5" />
        <circle cx="62" cy="278" r="5" />
        <circle cx="296" cy="322" r="5" />
        <circle cx="150" cy="60" r="5" />
        <circle cx="255" cy="497" r="5" />
        <circle cx="372" cy="430" r="5" />
      </g>
    </svg>;
}